import proxy from "../proxy";
const activation = {
  list:
    (data = {}) =>
    async (dispatch) =>
      await proxy.get("activation/list", data, { dispatch }),
  update:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.put("activation/update", data);
      await proxy.get("activation/list", data2, { dispatch });
    },
  updateStatus:
    (data = {}) =>
    async (dispatch) => {
      await proxy.put("activation/updateStatus", data, { dispatch });
    },
  add:
    (data = {}) =>
    async (dispatch) => {
      await proxy.post("activation/add", data);
    },
  del:
    (data = {}, data2 = {}) =>
    async (dispatch) => {
      await proxy.delete("activation/delete", data);
      await proxy.get("activation/list", data2, { dispatch });
    },
};

export default activation;
